<template>
  <v-app>
    <default-bar/>
    <default-drawer/>
    <default-view/>
    <default-footer/>
    <!--    <default-settings @mini="true"/>-->
    <v-snackbar :color="color" v-model="computedShow" :timeout="time">
      {{ mensagem }}
      <template v-slot:action="{ attrs }">
        <v-btn color="white" text v-bind="attrs" @click="computedShow = false">
          Fechar
        </v-btn>
      </template>
    </v-snackbar>
    <nexomed-loading-dialog
        :loading="computedShowLoading"
    ></nexomed-loading-dialog>
  </v-app>
</template>

<script>
import {Component, Vue} from 'vue-property-decorator';
import {namespace} from 'vuex-class';
import NexomedLoadingDialog from "@/components/NexomedLoadingDialog.vue";

const snackbar = namespace('snackbar');
const loading = namespace('loading');

@Component({
  name: "DefaultLayout",
  components: {
    DefaultBar: () => import(/* webpackChunkName: "default-app-bar" */'./AppBar'),
    DefaultDrawer: () => import(/* webpackChunkName: "default-drawer" */'./Drawer'),
    DefaultFooter: () => import(/* webpackChunkName: "default-footer" */'./Footer'),
    DefaultSettings: () => import(/* webpackChunkName: "default-settings" */'./Settings'),
    DefaultView: () => import(/* webpackChunkName: "default-view" */'./View'),
    NexomedLoadingDialog,
  }
})
export default class DefaultLayout extends Vue {

  @snackbar.Getter('color') color;
  @snackbar.Getter('show') show;
  @snackbar.Getter('time') time;
  @snackbar.Getter('mensagem') mensagem;
  @snackbar.Action('setSnackbarShow') setSnackbarShow;

  @loading.Getter('showLoading') showLoading;

  // computed
  get computedShowLoading() {
    return this.showLoading;
  }

  // computed
  get computedShow() {
    return this.show;
  }

  // computed
  set computedShow(val) {
    this.setSnackbarShow(val);
  }

}
</script>
